var _path, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#linkedin_svg__a)",
    fillRule: "evenodd",
    d: "M38.38 41A2.61 2.61 0 0 0 41 38.401V17.599A2.61 2.61 0 0 0 38.38 15H17.62A2.61 2.61 0 0 0 15 17.599v20.802A2.61 2.61 0 0 0 17.62 41h20.76ZM23.457 21.358c0 .955-.714 1.729-1.887 1.729-1.104 0-1.818-.774-1.818-1.73 0-.954.736-1.729 1.865-1.729 1.128 0 1.817.75 1.84 1.73Zm-3.613 14.214V24.45h3.498v11.122h-3.498Zm5.591-7.574c0-1.387-.045-2.547-.092-3.548h3.038l.162 1.547h.07c.459-.728 1.587-1.797 3.474-1.797 2.302 0 4.027 1.525 4.027 4.8v6.572h-3.497v-6.163c0-1.434-.507-2.411-1.773-2.411-.966 0-1.54.659-1.795 1.296-.092.227-.115.545-.115.863v6.413h-3.497v-7.574l-.002.002Z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    x: 0.5,
    y: 0.5,
    stroke: "#00CA72",
    rx: 27.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linkedin_svg__a",
    x1: 41.317,
    x2: 14.986,
    y1: 27.598,
    y2: 27.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CA72",
    stopOpacity: 0.2
  })))));
};
export default SvgLinkedin;